import React from 'react';
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  Typography
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

const ClientCard = ({
  id,
  name,
  is_live,
  is_configured,
  handleClientCardClick
}) => {
  return (
    <Card sx={{ borderRadius: 1.5, height: '100%' }}>
      <CardActionArea
        onClick={() => handleClientCardClick(id, name)}
        sx={{ height: '100%' }}
      >
        <CardContent>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 1
            }}
          >
            <Typography variant="subtitle1" fontWeight="bold">
              {name}
            </Typography>
            <Chip
              label={is_live ? 'Live' : 'Not Live'}
              size="small"
              color={is_live ? 'success' : 'default'}
              variant={is_live ? 'filled' : 'outlined'}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              fontFamily: 'Inter',
              fontWeight: 500,
              fontSize: 12,
              color: 'text.primary',
              gap: 0.5
            }}
          >
            {is_configured ? (
              <>
                <CheckCircleIcon sx={{ fontSize: 16, color: 'success.main' }} />
                Configured
              </>
            ) : (
              <>
                <ErrorIcon sx={{ fontSize: 16, color: 'error.main' }} />
                Not configured
              </>
            )}
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default ClientCard;
